import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	headerContainer: {
		padding: theme.spacing(0, 1),
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100]),
		height: 56,
		/**
		 * This property is the result of fixing the design bug in the bot,
		 * because when changing the position property of the react-flow lib,
		 * the bot's flow started to override the header.
		 */
		zIndex: 1000
	},
	headerContent: {
		flex: 1
	},
	flowContainer: {
		height: "100%",
		flex: 1
	},
	pageContainer: {
		position: "fixed",
		top: 0,
		left: 0,
		height: "100%",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		zIndex: 1203
	},
	saveButton: {
		fontSize: "14px",
		color: colors.gray[0],
		padding: theme.spacing(1, 2)
	},
	lastChangeIcon: {
		width: theme.spacing(2),
		height: theme.spacing(2),
		color: "rgba(73, 80, 87, 0.8)"
	},
	lastChangeText: {
		color: "rgba(73, 80, 87, 0.8)"
	},
	validationButton: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[500]),
		height: theme.spacing(2.75),
		borderRadius: theme.spacing(0.5),
		minWidth: 34,
		padding: theme.spacing(1, 1.5),
		fontSize: theme.spacing(1.5),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.yellow[400]),
			cursor: "pointer"
		}
	},
	validationButtonText: {
		fontSize: theme.spacing(1.75),
		color: colors.gray[0],
		fontWeight: 500,
		paddingLeft: theme.spacing(0.5),
		height: "100%",
		paddingBottom: theme.spacing(2.75)
	},
	picture: {
		width: "60%"
	},
	textValidationDialog: {
		fontSize: theme.spacing(2),
		lineHeight: "24px",
		fontWeight: 400,
		color: colors.gray[700]
	},
	validationDialogCancelButton: {
		padding: theme.spacing(1.25, 4),
		fontSize: theme.spacing(1.75),
		height: theme.spacing(5)
	},
	validationDialogSaveButton: {
		padding: theme.spacing(1.25, 4),
		...ColorUtil.getBackgroundAndContrastColor(colors.red[200]),
		fontSize: theme.spacing(1.75),
		height: theme.spacing(5)
	},
	validationDialogActions: {
		marginTop: theme.spacing(2),
		gap: theme.spacing(3)
	},
	activeSwitchThumb: {
		"& .MuiSwitch-thumb": {
			width: theme.spacing(2.5),
			height: theme.spacing(2.5),
			marginLeft: theme.spacing(3)
		}
	},
	disableSwitchThumb: {
		"& .MuiSwitch-thumb": {
			width: theme.spacing(2.5),
			height: theme.spacing(2.5)
		}
	},
	switchRoot: {
		"& .MuiSwitch-root": {
			width: "82px",
			height: "38px",
			display: "inline-flex",
			padding: "12px",
			zIndex: "0",
			overflow: "hidden",
			position: "relative",
			boxSizing: "border-box",
			flexShrink: "0",
			verticalAlign: "middle"
		}
	},
	backButton: {
		padding: theme.spacing(1, 2),
		borderRadius: theme.spacing(0.5),
		background: colors.gray[200],
		fontWeight: 700,
		fontSize: theme.spacing(2),
		color: colors.gray[700]
	},
	disableSelection: { "& > *": { pointerEvents: "none" } },
	tipsContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: theme.spacing(0.5),
		padding: theme.spacing(1.5, 2)
	},
	permissionWarningChip: {
		backgroundColor: colors.yellow[100],
		color: colors.yellow[800],
		fontWeight: 600,
		borderRadius: theme.spacing(0.5),
		"& .MuiChip-icon": {
			color: colors.yellow[800]
		}
	}
}))

export default useStyles
